import { useMemo } from 'react';
import { useJbpQuery, RestTypes } from './useJbpQuery';
import { StandingDataBookingReasonsResponse } from "../../../APIDocs/apiTypes";

export type BookingReason = {
    bookingPurposeId: number;
    bookingPurposeDescription: string;
}

export const useBookingReasons = (serviceLine: string): { isBookingReasonsLoading: boolean; bookingReasons: StandingDataBookingReasonsResponse | [] } => {

    const { isLoading: loadingBookingReasonsResponse, data: bookingReasonsResponse } = useJbpQuery<StandingDataBookingReasonsResponse, undefined>(
        RestTypes.Get,
        undefined,
        ['getBookingReasons'],
        `jbp/standingData/bookingReasons`,
        true,
        serviceLine,
        undefined,
        undefined,
        60000);


    const bookingReasons: StandingDataBookingReasonsResponse | undefined = useMemo(() => {
        return bookingReasonsResponse as StandingDataBookingReasonsResponse
    }, [bookingReasonsResponse]);

    return { isBookingReasonsLoading: loadingBookingReasonsResponse, bookingReasons: bookingReasons ?? [] };
};
